import { I18n } from '@lingui/core';
import { type AnyRouter } from '@tanstack/router-core';

export type RouterSsrLinguiOptions<TRouter extends AnyRouter> = {
  router: TRouter;
  i18n: I18n;
};

type DehydratedRouterQueryState = {
  dehydratedI18n: {
    locale: string;
    messages: Record<string, string>;
  };
};

export function setupCoreLinguiSsrIntegration<TRouter extends AnyRouter>({
  router,
  i18n,
}: RouterSsrLinguiOptions<TRouter>) {
  const ogHydrate = router.options.hydrate;
  const ogDehydrate = router.options.dehydrate;

  if (router.isServer) {
    router.options.dehydrate = async (): Promise<DehydratedRouterQueryState> => {
      //   router.serverSsr!.onRenderFinished(() => queryStream.close());

      const dehydratedRouter = {
        dehydratedI18n: {
          locale: i18n.locale,
          messages: i18n.messages,
        },
      };

      const ogDehydrated = await ogDehydrate?.();

      return {
        ...ogDehydrated,
        ...dehydratedRouter,
      };
    };

    // on the client
  } else {
    router.options.hydrate = async (dehydrated: DehydratedRouterQueryState) => {
      await ogHydrate?.(dehydrated);

      // On the client, hydrate the i18n catalog with the dehydrated data
      i18n.loadAndActivate({
        locale: dehydrated.dehydratedI18n.locale,
        messages: dehydrated.dehydratedI18n.messages,
      });
    };
  }
}
